import { 
  MapPin, 
  FileCheck, 
  Users, 
  Gem, 
  HeadphonesIcon,
  Shield
} from "lucide-react";

const WhyChooseUsSection = () => {
  const reasons = [
    {
      icon: MapPin,
      title: "Locally Owned & Operated",
      description: "We're a Los Angeles-based company with deep roots in the community we serve.",
    },
    {
      icon: FileCheck,
      title: "Transparent Written Estimates",
      description: "Receive detailed, itemized estimates before any work begins. No surprises.",
    },
    {
      icon: Users,
      title: "Experienced Landscaping Crew",
      description: "Our team has years of experience creating beautiful outdoor spaces.",
    },
    {
      icon: Gem,
      title: "Quality Materials",
      description: "We use premium plants, soil, and materials for lasting results.",
    },
    {
      icon: HeadphonesIcon,
      title: "Dedicated Customer Support",
      description: "Questions or concerns? Our team is here to help every step of the way.",
    },
    {
      icon: Shield,
      title: "Licensed & Insured",
      description: "Fully licensed and insured for your peace of mind and protection.",
    },
  ];

  return (
    <section
      data-testid="why-choose-us-section"
      className="section-padding bg-white"
    >
      <div className="container mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 text-[#C2410C] font-medium text-sm mb-4">
            <Shield className="w-4 h-4" />
            Why CasaCurate
          </span>
          <h2
            data-testid="why-choose-us-headline"
            className="font-heading text-3xl md:text-4xl lg:text-5xl text-[#1A2C22] font-bold mb-6"
          >
            Why Choose Us
          </h2>
          <p className="text-[#4B5563] text-base md:text-lg max-w-2xl mx-auto">
            We're committed to providing exceptional landscaping services with professionalism and integrity.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              data-testid={`reason-${index}`}
              className="group p-6 rounded-2xl bg-[#FAFAF8] hover:bg-[#F3F4F1] transition-all duration-300"
            >
              <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center mb-5 shadow-sm group-hover:shadow-md transition-shadow">
                <reason.icon className="w-6 h-6 text-[#2D5A27]" />
              </div>
              <h3 className="font-heading text-lg font-semibold text-[#1A2C22] mb-3">
                {reason.title}
              </h3>
              <p className="text-[#4B5563] text-sm leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
